/** Isolated preview adapter. Not production data. */
import { buildFunnel } from '../lib/funnel';
import type { Conversation, FollowUp, KnowledgeItem, SalesAgentBundle, SalesLead, SalesOverview } from '../types/contracts';

const NOW = new Date().toISOString();

export const MOCK_OVERVIEW: SalesOverview = {
  source: 'mock',
  range: { from: '2026-07-13', to: '2026-08-11' },
  kpis: [
    { key: 'conversations', value: 48, previous: 31, change_pct: 54.8, trend: 'up' },
    { key: 'new_leads', value: 22, previous: 18, change_pct: 22.2, trend: 'up' },
    { key: 'qualified_leads', value: 11, previous: 9, change_pct: 22.2, trend: 'up' },
    { key: 'hot_leads', value: 4, previous: 3, change_pct: 33.3, trend: 'up' },
    { key: 'demos_trials', value: 6, previous: 4, change_pct: 50, trend: 'up' },
    { key: 'signups', value: 3, previous: 2, change_pct: 50, trend: 'up' },
    { key: 'paid_customers', value: 2, previous: 1, change_pct: 100, trend: 'up' },
    { key: 'conversion_rate', value: 4.2, previous: 3.2, change_pct: 31.3, trend: 'up' },
  ],
  funnel: buildFunnel({ conversations: 48, leads: 22, qualified: 11, interested: 8, demo_trial: 6, paid: 2 }),
  recent_conversations: [{
    id: 'c-1', lead_name: 'Nour Hassan', business: 'Atelier Elegance', channel: 'whatsapp',
    last_message: 'Is Professional billed yearly?', last_activity_at: NOW, score: 87,
    stage: 'qualified', assigned_agent: 'Sara', status: 'active', handoff_status: 'AI_ACTIVE',
  }],
  hot_leads: [{
    id: 101, name: 'Nour Hassan', business: 'Atelier Elegance', score: 87,
    interested_plan: 'Professional', last_activity_at: NOW, objection: 'Price', next_action: 'Follow-up today',
  }],
};

export const MOCK_CONVERSATIONS: Conversation[] = [{
  id: 'c-1', lead_id: 101, lead_name: 'Nour Hassan', business: 'Atelier Elegance', channel: 'whatsapp',
  score: 87, stage: 'qualified', interested_plan: 'Professional', handoff_status: 'AI_ACTIVE',
  status: 'active', unread: true, last_message: 'Is Professional billed yearly?', last_activity_at: NOW,
  messages: [
    { id: 'm1', author: 'customer', body: 'How much is DressnMore?', at: NOW },
    { id: 'm2', author: 'ai', body: 'I can walk you through the live subscription plans.', at: NOW },
    { id: 'm3', author: 'system', body: 'Lead qualified', at: NOW },
  ],
  events: [{ id: 'e1', type: 'qualified', body: 'Lead qualified', at: NOW }],
  insight: {
    intent: 'pricing_inquiry', recommended_action: 'Recommend Professional',
    score: { value: 87, max: 100, band: 'hot' },
    summary: 'Atelier Elegance — 2 branches. Interested in Professional. Objection: price.',
  },
  snapshot: {
    name: 'Nour Hassan', business: 'Atelier Elegance', phone: '+20 100 000 0000', country: 'Egypt',
    branch_count: 2, user_count: 7, current_software: 'Excel', pain_point: 'Reservations and inventory',
    interested_plan: 'Professional', score: 87, stage: 'qualified', source: 'ai_sales',
  },
}];

export const MOCK_LEADS: SalesLead[] = [{
  id: 101, name: 'Nour Hassan', business: 'Atelier Elegance', phone: '+20 100 000 0000',
  email: 'nour@example.com', country: 'Egypt', branch_count: 2, user_count: 7, channel: 'whatsapp',
  stage: 'qualified', score: 87, interested_plan: 'Professional', last_activity_at: NOW,
  next_follow_up_at: NOW, owner: 'Sara', status: 'qualified', objection: 'Price',
  next_action: 'Follow-up today', summary: 'Atelier Elegance — 2 branches. Interested in Professional.',
  intent: 'pricing_inquiry', recommended_action: 'Handle price objection', handoff_status: 'AI_ACTIVE',
  source: 'ai_sales',
  timeline: [{ id: 'e1', type: 'note', body: 'Customer asked about Professional pricing.', at: NOW }],
  conversations: [{ id: 'c-1', channel: 'whatsapp', last_activity_at: NOW }],
}];

export const MOCK_FOLLOWUPS: FollowUp[] = [{
  id: 1, lead_id: 101, lead_name: 'Nour Hassan', business: 'Atelier Elegance',
  reason: 'Price objection — follow up after 24 hours.', scheduled_at: NOW, channel: 'whatsapp',
  suggested_message: 'Shall I compare Starter vs Professional for two branches?', status: 'pending',
}];

export const MOCK_KNOWLEDGE: KnowledgeItem[] = [{
  id: 1, title: 'What is DressnMore?', category: 'product', status: 'published', source: 'manual',
  content: 'An operating system for fashion ateliers: rental, sale, tailoring, inventory, bookings.',
  updated_at: NOW,
}];

export const MOCK_AGENT: SalesAgentBundle = {
  name: 'Sara', default_language: 'ar', supported_languages: ['ar', 'en'],
  personality: { professional: 80, friendly: 70, concise: 60, consultative: 85, persuasive: 55 },
  sales_behavior: {
    greeting: 'warm', discovery: 'consultative', qualification: 'structured',
    recommendation: 'plan_fit', objection_handling: 'empathetic', closing: 'soft', handoff: 'policy',
  },
  handoff_rules: { triggers: ['customer_asks_for_human'] },
  business_rules: {
    pricing_source: 'subscription_system', plans: [], trial: {}, demo: {}, payment: {},
    policies: { discount_requires_human: true },
  },
};
